import { render, staticRenderFns } from "./AuditLog.vue?vue&type=template&id=138e5fd4&scoped=true&"
import script from "./AuditLog.vue?vue&type=script&lang=js&"
export * from "./AuditLog.vue?vue&type=script&lang=js&"
import style0 from "./AuditLog.vue?vue&type=style&index=0&id=138e5fd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138e5fd4",
  null
  
)

export default component.exports